import * as Sentry from '@sentry/react';
import { Component, type ErrorInfo } from 'react';

interface RemoteBoundaryProps {
  children: React.ReactNode;
  name?: string;
  microfrontend?: string;
  fallback?: React.ReactNode;
}

interface RemoteBoundaryState {
  hasError: boolean;
}

class RemoteBoundary extends Component<RemoteBoundaryProps, RemoteBoundaryState> {
  state: RemoteBoundaryState = { hasError: false };

  static getDerivedStateFromError(): RemoteBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: unknown, errorInfo: ErrorInfo): void {
    const { name = 'Remote microfrontend', microfrontend } = this.props;
    console.error(`${name} failed to render:`, error);
    Sentry.captureException(error, {
      tags: {
        component: name,
        ...(microfrontend ? { microfrontend } : {}),
      },
      contexts: { react: { componentStack: errorInfo.componentStack } },
    });
  }

  render(): React.ReactNode {
    const { hasError } = this.state;
    const { children, fallback = null } = this.props;

    if (hasError) {
      return fallback;
    }

    return children;
  }
}

export default RemoteBoundary;
